import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1663_69855)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.37037 14.8748C6.87383 14.8748 6.39602 14.6614 6.04938 14.2927L2.26439 10.2078C1.56173 9.451 1.58047 8.24786 2.31124 7.52986C3.042 6.80215 4.19436 6.83126 4.89702 7.57837L7.29542 10.1593L12.6356 3.7749C13.3008 2.98898 14.4532 2.90166 15.2214 3.58085C15.9896 4.26974 16.074 5.46318 15.4088 6.2588L8.75695 14.215C8.41967 14.6225 7.9325 14.8554 7.41722 14.8651C7.39848 14.8651 7.38911 14.8651 7.37037 14.8651V14.8748Z",
  fill: "currentColor"
}))), 'Check', {
  viewBox: '0 0 18 18'
});